const initialState = {
  modalDetailPengajuanProduktif: true,
  pengajuanLamaProduktif: true,
  listPengajuanProduktif: [],
  detailPengajuanProduktif: [],
  listPengajuanByIdProduktif: [],
  urlDokumenProduktif: "",
  valueColProduktif: "12",
  valueColPrevProduktif: "0",
  urlPreviewProduktif: "",
  titlePreviewProduktif: "",
  getListKategoriJsonProduktif: [],
  totalPencairanProduktif: [],
  listTotalTargetUserProduktif: [],
};

const pengajuanProduktifReducer = (state = initialState, action) => {
  // console.log(initialState, "INITIAL STATE");
  let { type, data } = action;
  switch (type) {
    case "SET_STEP_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        modalDetailPengajuanProduktif: data,
      };
    case "SET_ALL_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        listPengajuanProduktif: data,
      };
    case "SET_DETAIL_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        detailPengajuanProduktif: data,
      };
    case "SET_ALL_PENGAJUAN_BY_ID_PRODUKTIF":
      return {
        ...state,
        listPengajuanByIdProduktif: data,
      };
    case "SET_PENGAJUAN_LAMA_PRODUKTIF":
      return {
        ...state,
        pengajuanLamaProduktif: data,
      };
    case "SHOW_URL_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        urlDokumenProduktif: data,
      };
    case "PREVIEW_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        valueColProduktif: "6",
        valueColPrevProduktif: "6",
        urlPreviewProduktif: data,
        titlePreviewProduktif: data,
      };
    case "HIDE_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        valueColProduktif: "12",
        valueColPrevProduktif: "0",
        urlPreviewProduktif: "",
        titlePreviewProduktif: "",
      };
    case "SET_GET_LIST_KATEGORI_JSON":
      return {
        ...state,
        getListKategoriJsonProduktif: data,
      };
    case "SET_ALL_TOTAL_PENCAIRAN_PRODUKTIF":
      return {
        ...state,
        totalPencairanProduktif: data,
      };
    case "SET_ALL_TOTAL_USER_PRODUKTIF":
      return {
        ...state,
        listTotalTargetUserProduktif: data,
      };
    default:
      return state;
  }
};
export default pengajuanProduktifReducer;
